angular.module( 'acme.view.application.resources.equipment', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.equipment.assign',
  'acme.view.application.resources.equipment.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesEquipment = {
        name: 'application.resources.equipment',
        url: '/equipment',
        abstract: true,
        views: {
          "subview-main": {
            templateUrl: 'views/application/views/resources/equipment/equipment.tpl.html'
          }
        }
      },
      resourcesEquipmentList = {
        name: 'application.resources.equipment.list',
        url: '',
        views: {
          "subview-main": {
            controller: 'ResourcesEquipmentController',
            templateUrl: 'views/application/views/resources/equipment/equipmentList.tpl.html'
          }
        },
        data: {
          pageTitle: 'Equipment Manager',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.facilities.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(resourcesEquipment)
      .state(resourcesEquipmentList);
});
